import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconDirectionComponent } from "./med-icon-direction.component";

@NgModule({
  declarations: [
    MedIconDirectionComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconDirectionComponent,
  ],
})
export class MedIconDirectionModule { }
